import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { IReservation } from '../../../shared/booking/model/reservation.model';

import { ReservationService } from '../../reservation/reservation.service';
import { ReservationCustomerService } from '../../../shared/booking/services/reservation-customer.service';
import { MatTableDataSource } from '@angular/material/table';
import { LocalStorageService } from 'ngx-webstorage';
import { Status } from '../../../types/enums';
import { ScheduleAppointmentService } from '../../schedule-appointment/schedule-appointment.service';
import { SessionStorageService } from 'ngx-webstorage';
import { AlertService } from '../../../shared/alert/alert.service';

@Component({
  selector: 'app-event-dialog',
  standalone: false,
  templateUrl: './event-dialog.component.html',
  styleUrls: ['./event-dialog.component.scss'],
})
export class EventDialogComponent implements OnInit {
  title?: string;

  @Input()
  reservationIds!: number[];

  reservationCustomers: any[] = [];

  displayedColumns: string[] = [
    'reservationNumber',
    'name',
    'startReservationLocalDate',
    'endReservationLocalDate',
    'duration',
    'utilities',
    'resources',
    'status',
  ];

  dataSource = new MatTableDataSource<IReservation>([]);

  constructor(
    protected reservationService: ReservationService,
    protected reservationCustomerService: ReservationCustomerService,
    protected router: Router,
    public activeModal: NgbActiveModal,
    private localStorageService: LocalStorageService,
    private scheduleAppointmentService: ScheduleAppointmentService,
    private sessionStorage: SessionStorageService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    if (this.reservationIds && this.reservationIds.length > 0) {
      this.reservationService.getByIds(this.reservationIds).subscribe((res) => {
        const data = res.body?.data || [];
        this.reservationCustomers = data;
        this.dataSource.data = data;
      });
    }
  }
  

  openUserNavigation(selectedUserId: number): void {
    this.router.navigate(['/user'], {
      queryParams: { userId: selectedUserId },
    });
    this.activeModal.dismiss();
  }

  openScheduleAppointment(selectedReservationNumber: string): void {
    if (selectedReservationNumber !== undefined) {
      this.router.navigate(['/review-reservation', selectedReservationNumber]);
    }
    this.activeModal.dismiss();
  }

  getFormattedDate(date: Date): Date {
    // No timezone offset needed - Angular handles UTC to local conversion automatically
    return new Date(date);
  }

  onStatusCancel(reservation: IReservation, customerId: number): void {
    reservation.statusId = Status.Cancelled;
    this.reservationService.statusUpdateForCustomer(reservation, customerId).subscribe((res) => {
      if (res.body === null) {
        const locale = this.localStorageService.retrieve('locale');
        const lang = locale || 'sr';
        if (lang === 'sr') {
          this.alertService.error('Otkazivanje nije dozvoljeno!');
        }
        if (lang === 'en') {
          this.alertService.error('Cancellation is not allowed!');
        }
      } else {
        this.reservationService.cancelStatus();
        this.activeModal.dismiss();
        this.alertService.success('Uspešno ste otkazali rezervaciju');
      } 
    });
    // OTKAZIVANJE CELE REZERVACIJE:
    // reservation.statusId = Status.Cancelled;
    // this.reservationService.statusUpdate(reservation).subscribe(res => {
    //   this.reservationService.cancelStatus();
    //   this.activeModal.dismiss();
    // });
  }

  cancel(): void {
    this.activeModal.dismiss();
  }

  openNewScheduleAppointment(): void {
    // Get full reservation data to extract resourceId / utilityIds for pre-population
    if (this.reservationIds) {
      // Collect customer ids from already loaded rows so we can preselect them in scheduler
      const customerIds: number[] = [];
      (this.reservationCustomers || []).forEach((row: any) => {
        const id = row?.technouserid;
        if (id && !customerIds.includes(id)) {
          customerIds.push(id);
        }
      });

      
      this.scheduleAppointmentService
        .getReservationsByIds(this.reservationIds as any)
        .subscribe(
          (res: any) => {
            const reservations = res.body || [];
            if (reservations.length > 0) {
              const firstReservation = reservations[0];
              
              // Extract resourceId and utilityIds from reservation data
              const resourceId = firstReservation.resourceId;
              const utilityIds: number[] = [];

              // Collect all unique utilityIds from all reservations
              this.reservationCustomers.forEach((reservation: any) => {
                if (reservation.utilities_id && !utilityIds.includes(reservation.utilities_id)) {
                  utilityIds.push(reservation.utilities_id);
                }
              });

              // Store pre-population data in sessionStorage
              this.sessionStorage.store('scheduleAppointmentPrePopulate', {
                resourceId: resourceId,
                utilityIds: utilityIds,
                customerIds: customerIds,
                reservationId: this.reservationIds,
                reservationStart: firstReservation.startReservationLocalDate
              });

              // Navigate to schedule-appointment page which will open the modal
              this.router.navigate(['/booking/schedule-appointment'], {
                queryParams: {
                  openModal: 'true',
                  reservationId: firstReservation.id,
                  _reload: Date.now()
                },
              });
            } else {
              // Fallback if no data found
              this.router.navigate(['/booking/schedule-appointment'], {
                queryParams: {
                  reservationId: this.reservationIds,
                },
              });
            }
          },
          () => {
            // On error, still navigate so user can manually schedule
            this.router.navigate(['/booking/schedule-appointment'], {
              queryParams: {
                reservationId: this.reservationIds,
              },
            });
          }
        );
    } else {
      // Fallback if no reservationId
      this.router.navigate(['/booking/schedule-appointment']);
    }
    this.activeModal.dismiss();
  }

  filteredReservations(): IReservation[] {
    return this.reservationCustomers.filter(
      (reservation) => reservation.customerStatusId !== Status.Cancelled
    );
  }
}
